// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"BasicSummaryMenu_horizontal__1iMYM","summary-menu":"BasicSummaryMenu_summary-menu__x0fF8","summary-menu__item":"BasicSummaryMenu_summary-menu__item__2vNPx"};